import Vue from 'vue';
import _ from 'lodash';
import { SEARCH, HTTP } from '@/utils/http';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';
import * as mutationTypes from '@/store/types/mutations';

const getters = {
  [getterTypes.GET_EPISODE]: state => state.episode,
  [getterTypes.GET_EPISODES]: state => state.episodes,
  [getterTypes.GET_EPISODES_AGGREGATIONS]: state => state.aggs,
  [getterTypes.GET_EPISODES_AGGREGATIONS_BY_CHANNEL](state) {
    if (_.isEmpty(state.aggs)) return [];
    const { buckets } = state.aggs.by_account.channels.nested_channels;
    return _.map(buckets, (bucket) => {
      let id = null;
      let img = null;
      const hit = bucket.channel.hits.hits[0];
      if (hit) {
        id = hit._source.id;
        if (hit._source._embedded && hit._source._embedded.artwork) {
          img = hit._source._embedded.artwork.cl_id;
        }
      }
      const obj = {
        count: bucket.doc_count,
        key: 'channels',
        id,
        img,
        label: bucket.key,
      };
      return obj;
    });
  },
  [getterTypes.GET_EPISODES_AGGREGATIONS_BY_SPEAKER](state) {
    if (_.isEmpty(state.aggs)) return [];
    const { buckets } = state.aggs.by_account.speakers;
    return _.map(buckets, (bucket) => {
      let id = null;
      let img = null;
      const hit = bucket.episode.hits.hits[0];
      if (hit) {
        const { speaker } = hit._source._embedded;
        id = speaker.id;
        if (speaker._embedded && speaker._embedded.profile_image) {
          img = speaker._embedded.profile_image.cl_id;
        }
      }
      const obj = {
        count: bucket.doc_count,
        key: 'speakers',
        id,
        img,
        label: bucket.key,
      };
      return obj;
    });
  },
  [getterTypes.GET_EPISODES_AGGREGATIONS_BY_TAGS](state) {
    if (_.isEmpty(state.aggs)) return [];
    const { buckets } = state.aggs.by_account.tags;
    return _.map(buckets, (bucket) => {
      const obj = {
        count: bucket.doc_count,
        key: 'tags',
        id: bucket.key,
        label: bucket.key,
      };
      return obj;
    });
  },
  [getterTypes.GET_EPISODES_AGGREGATIONS_BY_YEAR](state) {
    if (_.isEmpty(state.aggs)) return [];
    const { buckets } = state.aggs.by_account.years;
    return _.map(buckets, (bucket) => {
      const obj = {
        count: bucket.doc_count,
        key: 'years',
        id: parseInt(bucket.key_as_string, 10),
        label: bucket.key_as_string,
      };
      return obj;
    });
  },
  [getterTypes.GET_EPISODES_PAGINATION]: state => state.pagination,
};

const actions = {
  async [actionTypes.DO_GET_EPISODE]({ commit }, payload) {
    const { id, ...params } = payload;
    const { data } = await HTTP.get(`/episodes/${id}`, { params });
    commit(mutationTypes.SET_EPISODE, data.data.episodes[0]);
    return data;
  },
  async [actionTypes.DO_GET_EPISODES]({ commit }, payload) {
    const { method, ...params } = payload;
    const { data } = await SEARCH.post('/doxa_episodes/_search', params);
    if (data.hits.total > 0) {
      const mutation = method === 'append' ? mutationTypes.APPEND_EPISODES : mutationTypes.SET_EPISODES;
      commit(mutation, data.hits.hits.map(h => h._source));
      return data;
    }
    commit(mutationTypes.SET_EPISODES, []);
    return data;
  },
};

const mutations = {
  [mutationTypes.APPEND_EPISODES](state, episodes) {
    state.episodes = state.episodes.concat(episodes);
  },
  [mutationTypes.SET_EPISODE](state, episode) {
    state.episode = episode;
  },
  [mutationTypes.SET_EPISODES](state, episodes) {
    state.episodes = episodes;
  },
  [mutationTypes.SET_EPISODES_AGGREGATIONS](state, aggs) {
    state.aggs = aggs;
  },
  [mutationTypes.SET_EPISODES_PAGINATION_FIELD](state, payload) {
    Vue.set(state.pagination, payload.key, payload.val);
  },
};

export default {
  state: {
    aggs: {},
    episode: {},
    episodes: [],
    pagination: {
      page: 1,
      per: 12,
      total: 0,
    },
  },
  getters,
  actions,
  mutations,
};
